// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-orders{width:230px;right:-230px;max-width:100vw}.control-sidebar{padding:5rem 0 0 0!important;overflow-y:scroll;max-height:100vh;border:none;box-shadow:1px 0 5px rgb(0 0 0/10%)}.control-sidebar::-webkit-scrollbar{display:none}", ""]);
// Exports
module.exports = exports;
